import { useNotificationPolling } from "@hooks/shared/use-notification-polling";
import { useRealtimeSession } from "@hooks/shared/use-realtime-session";
import { useThemePreferencesSync } from "@hooks/shared/use-theme-preferences-sync";
import { useWidgetCacheReset } from "@hooks/client/use-widget-cache-reset";

// The work that runs for a signed-in session and has no UI of its own. Renders nothing; it
// exists so the hooks run inside AuthProvider and ThemeProvider, which App itself is not.
// New session-wide background work goes here as a hook, not as another empty component.
export const SessionEffects = () => {
  useNotificationPolling();
  useRealtimeSession();
  useThemePreferencesSync();
  useWidgetCacheReset();
  return null;
};
